<!--
 * @Author: your name
 * @Date: 2021-06-24 10:24:21
 * @LastEditTime: 2021-09-06 17:26:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fmg-project\pc\src\components\Footer.vue
-->
<template>
  <div class="publicFooter">
    <div class="footerBox">
      <div class="box">
        <div class="title">M Space</div>
        <div class="content">
          <p>{{ $t("Footer.slogan") }}</p>
        </div>
      </div>
      <div class="box">
        <div class="title">{{ $t("Footer.about") }}</div>
        <div class="content">
          <p
            @click.stop="
              $store.dispatch('changeRouter', {
                path: '/about',
                query: { typeId: 'user' },
              })
            "
          >
            {{ $t("Footer.userAbout") }}
          </p>
          <p
            @click.stop="
              $store.dispatch('changeRouter', {
                path: '/about',
                query: { typeId: 'privacy' },
              })
            "
          >
            {{ $t("Footer.privacyAbout") }}
          </p>
        </div>
      </div>
      <div class="box">
        <div class="title">{{ $t("Footer.contact") }}</div>
        <div class="content">
          <ul>
            <li v-for="(item, index) in 7" :key="index">
              <div class="icon" @click.stop="changeLink(item)">
                <img
                  :src="require(`@/assets/images/footer/f${item}.png`)"
                  class="normal"
                />
                <img
                  :src="require(`@/assets/images/footer/f${item}Active.png`)"
                  class="active"
                />

                <img
                  src="@/assets/images/footer/qr.jpg"
                  class="qr"
                  v-if="index == 6"
                />
                <p class="ID" v-if="index == 5">Clubhouse ID：@feiming</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <span class="copy">@2021 M Space All rights reserved.</span>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    changeLink(index) {
      let url = "";
      switch (index) {
        case 1:
          url = "https://t.me/mspaceofficial";
          break;
        case 2:
          url = "https://twitter.com/fm_gallery";
          break;
        case 3:
          url = "https://www.instagram.com/accounts/login/";
          break;
        case 4:
          url = "https://discord.com/invite/ga2MGD4PQV";
          break;
        case 5:
          url = "https://mspacenews.medium.com/";
          break;
      }
      if (url) {
        window.open(url);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.publicFooter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 70px 0 22px;
  font-size: 16px;
  color: #767d90;
  border-top: 1px solid #ebebeb;
  .footerBox {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-bottom: 100px;
    .box {
      .title {
        font-size: 24px;
        color: #000;
        margin-bottom: 55px;
      }
      .content {
        p {
          margin-bottom: 20px;
          max-width: 300px;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
        }
        ul {
          display: flex;
          align-items: center;
          li {
            margin-right: 20px;
            &:last-child {
              margin-right: 0;
            }
            .icon {
              border: 1px solid #77c9c2;
              border-radius: 10px;
              width: 36px;
              height: 36px;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s;
              cursor: pointer;
              position: relative;
              &:hover {
                background: linear-gradient(135deg, #adacda 0%, #9fbfe3 100%);
                .ID {
                  opacity: 1;
                }
                img {
                  &.normal {
                    display: none;
                  }
                  &.active {
                    display: block;
                  }
                  &.qr {
                    opacity: 1;
                  }
                }
              }

              img {
                height: 12px;
                transition: all 0.2s;
                &.qr {
                  opacity: 0;
                  position: absolute;
                  width: 120px;
                  height: 120px;
                  top: -120px;
                  left: -42px;
                }
                &.active {
                  display: none;
                }
              }

              .ID {
                opacity: 0;
                position: absolute;
                width: 200px;
                height: 30px;
                top: -30px;
                left: -85px;
              }
            }
          }
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Footer.vue